import Icon from '../components/Icon.vue'

Icon.register({"adjust":{"width":512,"height":512,"paths":[{"d":"M8 256C8 393 119 504 256 504S504 393 504 256 393 8 256 8 8 119 8 256zM256 440V72C357.7 72 440 154.3 440 256 440 357.7 357.7 440 256 440z"}]}})
